import React from 'react';
import BreadCrumbItem, { IBreadCrumbItem } from './BreadCrumbItem';
import {
  Breadcrumbs,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

export interface IBreadCrumb {
  itens: IBreadCrumbItem[];
}

export interface IBreadCrumbState {}

const useStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        overflow: 'hidden',
        '& .MuiBreadcrumbs-ol': {
          flexWrap: 'nowrap',
          '& .MuiBreadcrumbs-li': {
            display: 'flex',
            maxWidth: '60%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          },
        },
      },
    }),
  { name: 'SicrediBreadcrumb' }
);

export default ({ itens }: IBreadCrumb) => {
  const classes = useStyle();
  return (
    <Breadcrumbs separator=">" className={classes.root}>
      {itens.map((item: IBreadCrumbItem, index: number) => {
        return <BreadCrumbItem {...item} key={index} />;
      })}
    </Breadcrumbs>
  );
};
